export enum SortByInformes {
    ID = 'id',
}

export enum KeysInformes {
    REPORT_RESULTS = 'informes_resultados',
}
